var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout-row flex layout-align-center-center",attrs:{"title":"Kommentar"}},[_c('v-icon',{attrs:{"dark":_vm.compColor.isInDarkMode}},[_vm._v(_vm._s(this.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }